var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandAppointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#9381FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7472 15.8317C30.5854 20.1977 24.8319 24.4973 16.9252 28.6829C17.3045 27.8488 17.6042 27.2094 17.806 26.9323C18.5046 25.9678 19.9255 23.2364 19.9255 23.2364C19.9255 23.2364 20.6741 23.7576 20.7759 23.5172C20.8759 23.2761 25.1119 13.1936 25.1119 13.1936C25.1119 13.1936 23.1147 10.9645 22.4005 12.5988C21.9297 13.6782 17.7234 23.3079 14.9239 29.7163C14.3838 29.9874 13.8371 30.2608 13.2792 30.5319C12.6529 30.8068 12.9766 31.4935 13.9574 31.9276C13.0344 34.0427 12.4206 35.4479 12.4206 35.4479C12.4206 35.4479 12.4017 36.151 12.9092 35.9702C13.7693 34.9449 14.5689 33.5662 15.272 32.1876C20.5848 31.7223 34.7064 20.2557 35.4295 19.1975C36.1741 18.1107 33.908 14.7486 33.7472 15.8317ZM16.0936 30.9698C15.9277 31.1254 15.6666 31.1158 15.5121 30.9513C15.3566 30.7853 15.3654 30.5246 15.531 30.369C15.6969 30.2135 15.9574 30.2223 16.1129 30.3883C16.2674 30.5534 16.2593 30.8149 16.0936 30.9698Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandAppointmentIcon);
export default __webpack_public_path__ + "static/media/brand-appointment-icon.8d08bb3a4b62ff2c0968836842862bcd.svg";
export { ForwardRef as ReactComponent };